import { SelectOption } from "react-spreadsheet-import/types/types";
import { PurchaseDetails } from "../components/purchase/PurchaseData.interface";
import { QuoteRequest, SaveForm } from "../components/quote/QuoteRequestData";
import { countries } from "../data/countries";
import { provinces } from "../data/province";
import { states } from "../data/states";
import { config } from "@brand";

const {mtiApiUrl} = config;

interface SavedQuoteResponse {
  ipAddress: string;
  id: string;
  timsetamp: string;
  quoteData: QuoteRequest | string;
  error?: any;
  agentNum: string;
  affiliateCode?: string;
}

export class SavedQuotes {
  public async getQuote(quoteId: string): Promise<SavedQuoteResponse | null> {
    const request = await fetch(`${mtiApiUrl}/quote-requests/${quoteId}`, {
      method: 'GET',
    })

    const savedQuote = await request.json() as SavedQuoteResponse;

    if (savedQuote.error) {
      // handle error
      return null;
    } else {

      savedQuote.quoteData = JSON.parse(savedQuote.quoteData as string) as QuoteRequest;
  
      const genderOptions = [{ label: 'Female', value: 'female' }, { label: 'Male', value: 'male' }];
      const stateOptions = states.concat(provinces);
      const countryOptions = [...countries, { label: 'United States', value: 'USA' }];
  
      savedQuote.quoteData.primaryInsured?.map(insured => {
        if (insured.residencyCountry) {
          insured.residencyCountryObject = this.setSelectObject(insured.residencyCountry, countryOptions)
        }
  
        if (insured.citizenship) {
          insured.citizenshipObject = this.setSelectObject(insured.citizenship, countryOptions)
        }
  
        if (insured.residencyState) {
          insured.residencyStateObject = this.setSelectObject(insured.residencyState, stateOptions)
        }
  
        if (insured.gender) {
          insured.genderObject = this.setSelectObject(insured.gender, genderOptions)
        }
  
        if (insured.children && insured.children.length > 0) {
          insured.children.map(child => {
            if (child.residencyCountry) {
              child.residencyCountryObject = this.setSelectObject(child.residencyCountry, countryOptions)
            }
  
            if (child.citizenship) {
              child.citizenshipObject = this.setSelectObject(child.citizenship, countryOptions)
            }
  
            if (child.residencyState) {
              child.residencyStateObject = this.setSelectObject(child.residencyState, stateOptions)
            }
  
            if (child.gender) {
              child.genderObject = this.setSelectObject(child.gender, genderOptions)
            }
          })
        }
  
        if (insured.spouse) {
          if (insured.spouse.residencyCountry) {
            insured.spouse.residencyCountryObject = this.setSelectObject(insured.spouse.residencyCountry, countryOptions)
          }
  
          if (insured.spouse.citizenship) {
            insured.spouse.citizenshipObject = this.setSelectObject(insured.spouse.citizenship, countryOptions)
          }
  
          if (insured.spouse.residencyState) {
            insured.spouse.residencyStateObject = this.setSelectObject(insured.spouse.residencyState, stateOptions)
          }
  
          if (insured.spouse.gender) {
            insured.spouse.genderObject = this.setSelectObject(insured.spouse.gender, genderOptions)
          }
        }
      });

      return savedQuote;
    }
  }
  
  public async saveQuote(quoteData: PurchaseDetails, contactListData:SaveForm, agentNum: string, affiliateCode = ''): Promise<any> {
      const request = await fetch(`${mtiApiUrl}/quote/save`, {
      method: 'POST',
      body: JSON.stringify({ quoteRequest: quoteData, agentNum: agentNum, affiliateCode: affiliateCode, ...contactListData}),
      headers: {
        'Content-Type': 'application/json'
      }
    })

    return await request.json();
  }

  private setSelectObject(value:string, options:SelectOption[]):SelectOption {
    return options.filter(option => option.value === value)[0];
  }
}
